import { AlertCircle } from 'lucide-react'
import { ReactNode } from 'react'

interface OmpFieldProps {
  label: string
  error?: string
  children: ReactNode
  className?: string
}

const OmpField = ({ label, error, children, className }: OmpFieldProps) => {
  return (
    <div className={className}>
      <label className="omp-form-label">{label}</label>
      {children}
      {error && (
        <p className="omp-form-error">
          <AlertCircle size={14} />
          {error}
        </p>
      )}
    </div>
  )
}

export default OmpField
